<template>
	<div
		class="guide"
		:style="{ 'background-position-y': $showTitle ? '46px' : '0' }"
		@click="sensorsClick"
	>
		<div style="height: 1.28rem;"></div>
		<div class="flex-box box-shadow nav-box">
			<div @click="toView('principle')">
				<img src="./images/icon@2x.png" alt="" />
				<div>3大购险原则</div>
			</div>
			<div @click="toView('pillar')">
				<img src="./images/icon-2@2x.png" alt="" />
				<div>3大保障支柱</div>
			</div>
			<div @click="toView('policy')">
				<img src="./images/icon-3@2x.png" alt="" />
				<div>
					6张人身保单
				</div>
			</div>
		</div>

		<h1>全面了解336购险指南</h1>
		<section>
			<!-- 3大购险原则 -->
			<div class="box-shadow main-box" id="principle">
				<div class="box-title">
					3大购险原则 <img src="./images/box-r-1@2x.png" alt="" />
				</div>
				<div
					class="line-title"
					style="padding: 0;padding-left: .1rem;margin-bottom: .15rem;"
				>
					为谁买? - 先保高收入的
				</div>
				<p
					style="font-size: 0.11rem;font-family: FZLanTingHeiS-R-GB;font-weight: 400;color: #617080;padding-left:.1rem"
				>
					建议按下面的顺序投保：
				</p>
				<div class="flex-box family">
					<div>
						<img src="./images/nan@2x.png" alt="" />
						<p>家庭主要</p>
						<p>经济来源者</p>
					</div>
					<div class="p-t">
						<van-icon name="down" style="transform: rotate(-90deg);" />
					</div>
					<div>
						<img src="./images/nv@2x.png" alt="" />
						<p>家庭次要</p>
						<p>经济来源者</p>
					</div>
					<div class="p-t">
						<van-icon name="down" style="transform: rotate(-90deg);" />
					</div>
					<div>
						<img src="./images/zai@2x.png" alt="" />
						<p>家庭无经济</p>
						<p>来源者</p>
					</div>
				</div>
				<div class="line-title">买什么? - 尽量降低损失危害</div>
				<div class="line-box">
					<p><span>1</span> 把自己保护好，才能更好保护家人；</p>
					<p>
						<span>2</span>
						先解决当前风险，再解决未来风险；<br />举例：重疾随时可能发生，为当前风险；养老是退休后才面临的问题，为未来风险。
					</p>
					<p><span>3</span> 突发风险没有足够的准备时间，需优先考虑。</p>
				</div>
				<div class="line-title">怎么买？- 保障最大化</div>
				<ul class="bo-zhang-max">
					<li class="flex-box">
						<div>
							<img src="./images/1-1@2x.png" alt="" />
							<span>先买保障</span>
						</div>

						<img src="./images/1-c@2x.png" alt="" />
						<div>
							<img src="./images/1-2@2x.png" alt="" />
							<span>再看满期</span>
						</div>
					</li>
					<li class="flex-box">
						<div>
							<img src="./images/1-3@2x.png" alt="" />
							<span>先看保额够不够</span>
						</div>

						<img src="./images/1-c@2x.png" alt="" />
						<div>
							<img src="./images/1-4@2x.png" alt="" />
							<span>再看保多久</span>
						</div>
					</li>
					<li class="flex-box">
						<div>
							<img src="./images/1-5@2x.png" alt="" />
							<span>缴费期</span>
						</div>

						<img src="./images/1-c@2x.png" alt="" />
						<div>
							<img src="./images/1-6@2x.png" alt="" />
							<span>越长越好</span>
						</div>
					</li>
				</ul>
			</div>
			<br />
			<!-- 3大保障支柱 -->
			<div class="box-shadow main-box" id="pillar">
				<div class="box-title">
					3大保障支柱 <img src="./images/box-r-2@2x.png" alt="" />
				</div>
				<div>
					<div class="line-title">
						第一保障支柱：国家社会保险<img src="./images/2-1@2x.png" alt="" />
					</div>
					<br />
					<div class="flex-box pillar">
						<div>基本<br />养老保险</div>
						<van-icon name="plus" />
						<div>基本<br />医疗保险</div>
						<van-icon name="plus" />
						<div>工伤<br />保险</div>
						<van-icon name="plus" />
						<div>生育<br />保险</div>
						<van-icon name="plus" />
						<div>失业<br />保险</div>
					</div>
					<br />
					<p style="color: #617080;line-height: 0.19rem;">
						具有强制性，覆盖面广的特点，提供基础的养老、医疗等保障。<br />国家社会保险分为
						<span style="color:#1B3654;font-weight: bold;">
							基本养老保险、基本医疗保险、工伤保险、生育保险和失业保险
						</span>
						五大类，其中基本养老保险和基本医疗保险的保障作用最为明显。
					</p>
				</div>
				<br />
				<br />
				<div class="qiye">
					<div class="line-title">
						第二保障支柱：企业补充保险<img src="./images/2-2@2x.png" alt="" />
					</div>
					<br />
					<div class="flex-box pillar">
						<div>身故</div>
						<van-icon name="plus" />
						<div>重疾</div>
						<van-icon name="plus" />
						<div>医疗</div>
						<van-icon name="plus" />
						<div>养老</div>
						<van-icon name="plus" />
						<div>•••••</div>
					</div>
					<br />
					<p style="color: #617080;line-height: 0.19rem;">
						部分企业额外为员工提供了
						<span style="color:#1B3654;font-weight: bold;">
							身故、重疾、医疗、养老
						</span>
						等补充保障，通常离职或退休则不再享有，是一种阶段性补充，因此具有不确定性。
					</p>
				</div>
				<br />
				<br />
				<div class="geren">
					<div class="line-title">
						第三保障支柱：个人商业保险<img src="./images/2-3@2x.png" alt="" />
					</div>
					<br />
					<div class="flex-box pillar">
						<div>种类<br />齐全</div>
						<van-icon name="plus" />
						<div>因需<br />配置</div>
						<van-icon name="plus" />
						<div>可个<br />性化定制</div>
						<van-icon name="plus" />
						<div>涵盖<br />范围广</div>
					</div>
					<br />
					<p style="color: #617080;line-height: 0.19rem;">
						<span style="color:#1B3654;font-weight: bold;">
							种类齐全，因需配置，可个性化定制
						</span>
						。完全匹配个人及家庭不同人生时期的风险管理需求，
						<span style="color:#1B3654;font-weight: bold;">
							涵盖基础社会保障和企业补充保障的保障类型以及无法满足的保障需求。
						</span>
					</p>
				</div>
			</div>
			<br />
			<!-- 六张人生保单 -->
			<div class="box-shadow main-box" id="policy">
				<div class="box-title">
					6张人身保单<img src="./images/box-r-3@2x.png" alt="" />
				</div>
				<ul class="policy">
					<li class="flex-box">
						<img src="./images/3-1@2x.png" alt="" />
						<div>
							<h3>重疾险</h3>
							<p>
								确诊合同约定的重大疾病，即可获得赔付。既能弥补治疗费用，又能补偿误工或失业导致的收入损失。
							</p>
						</div>
					</li>
					<li class="flex-box">
						<img src="./images/3-2@2x.png" alt="" />
						<div>
							<h3>意外险</h3>
							<p>
								因合同约定的意外导致身故或残疾，即可获得赔付，可以降低意外对家庭经济造成的冲击。
							</p>
						</div>
					</li>
					<li class="flex-box">
						<img src="./images/3-3@2x.png" alt="" />
						<div>
							<h3>医疗险</h3>
							<p>
								如发生合同约定的治疗，可报销费用或给予津贴。赔付门槛较低，可选高额保障。
							</p>
						</div>
					</li>
					<li class="flex-box">
						<img src="./images/3-4@2x.png" alt="" />
						<div>
							<h3>寿险</h3>
							<p>
								疾病或意外身故均可获得赔付，降低家庭成员不幸离去对配偶和子女产生的经济压力。
							</p>
						</div>
					</li>
					<li class="flex-box">
						<img src="./images/3-5@2x.png" alt="" />
						<div>
							<h3>养老险</h3>
							<p>
								通常按年或月给付养老金，是社保养老的有效补充。
							</p>
						</div>
					</li>
					<li class="flex-box">
						<img src="./images/3-6@2x.png" alt="" />
						<div>
							<h3>传承险</h3>
							<p>
								财富传承给下一代的有效工具，确定性强，安全性高。
							</p>
						</div>
					</li>
				</ul>
			</div>
		</section>
		<router-link to="/question" tag="footer">
			<button class="btn" sensors-click>定制我的专属保障</button>
		</router-link>
	</div>
</template>

<script>
export default {
	methods: {
		toView(id) {
			document
				.getElementById(id)
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		},
		sensorsClick(e) {
			e.stopPropagation();
			let target = e.target;

			if (target.getAttributeNames().indexOf('sensors-click') != -1) {
				let text = target.innerText;
				const getText = target.getAttribute('sensors-click');
				getText && (text = getText);
				console.log('sensors-click', text);
				this.sensorsAdd('BDWebClick', {
					$element_content: text,
					$title: `336理念页`,
				});
			}
		},
	},
};
</script>

<style scoped>
.guide {
	background: url('./images/banner@2x.png') no-repeat top center, #eef6ff;
	background-size: 100%;
	padding: 0 0.15rem 1rem 0.15rem;
}
.flex-box {
	display: flex;
	justify-content: space-around;
}
.box-shadow {
	border-radius: 0.1rem;
	box-shadow: 0rem 0.1rem 0.06rem #ebedf0;
}
.nav-box {
	width: 3.2rem;
	padding: 0.16rem;
	background: white;
	font-size: 0.12rem;
	font-weight: bold;
	color: #1b3654;
	box-sizing: border-box;
	text-align: center;
}
.nav-box img {
	width: 0.3rem;
	height: 0.3rem;
	margin-bottom: 0.05rem;
}
h1 {
	font-size: 0.17rem;
	font-weight: 800;
	font-family: PingFang SC;
	color: #1b3654;
	line-height: 0.17rem;
	text-align: center;
	padding: 0.3rem;
	background: url('./images/l@2x.png') no-repeat,
		url('./images/r@2x.png') no-repeat;
	background-size: 0.16rem 0.19rem;
	background-position: 15% center, 85% center;
}
.main-box {
	position: relative;
	background: white;
	padding: 0.24rem 0.15rem;
	margin-top: 0.3rem;
	box-sizing: border-box;
}
.box-title {
	width: 3.2rem;
	height: 0.47rem;
	position: absolute;
	left: 0;
	top: -0.29rem;
	background: url('./images/bxo-top@2x.png') no-repeat;
	background-size: cover;
	font-size: 0.14rem;
	font-weight: 400;
	color: #ffffff;
	line-height: 0.32rem;
	padding-left: 0.15rem;
	box-sizing: border-box;
}
.box-title img {
	width: 0.45rem;
	position: absolute;
	top: 0.07rem;
	right: 0;
}

.line-title {
	font-size: 0.15rem;
	font-weight: 800;
	color: #1b3654;
	line-height: 0.17rem;
	padding: 0.18rem 0.1rem;
	box-sizing: border-box;
	position: relative;
}
.line-title::after {
	content: '';
	display: inline-block;
	width: 0.03rem;
	height: 0.15rem;
	border-radius: 0.03rem;
	background: #3b97ff;
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
}
.line-title img {
	width: 0.44rem;
	height: 0.51rem;
	position: absolute;
	top: 0;
	right: 0;
}
/* 3大购险原则 */
.family {
	text-align: center;
	font-size: 0.12rem;
	font-weight: 500;
	color: #617080;
	margin-top: 0.16rem;
	margin-bottom: 0.25rem;
}
.family img {
	width: 0.49rem;
	height: 0.49rem;
	margin-bottom: 0.1rem;
}
.line-box {
	margin-left: 0.1rem;
	padding-left: 0.2rem;
	border-left: 1px dashed #617080;
	font-size: 0.12rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: #617080;
	line-height: 0.19rem;
}
.line-box p {
	margin: 0.15rem 0;
	position: relative;
}
.line-box p > span {
	position: absolute;
	left: -0.3rem;
	width: 0.17rem;
	height: 0.17rem;
	border-radius: 50%;
	border: 1px solid #617080;
	text-align: center;
	background: white;
	display: flex;
	justify-content: center;
	align-items: center;
}
.bo-zhang-max li {
	align-items: center;
	margin-bottom: 0.4rem;
}
.bo-zhang-max li div {
	position: relative;
}
.bo-zhang-max li div > span {
	width: 110%;
	position: absolute;
	bottom: -0.25rem;
	left: 0;
	text-align: center;
}
.bo-zhang-max li div img {
	width: 0.79rem;
	height: 0.56rem;
}
.bo-zhang-max li > img {
	width: 0.28rem;
	height: 0.14rem;
}
.p-t {
	padding-top: 0.2rem;
}
/* 保障支柱 */
.pillar {
	align-items: center;
}
.pillar div {
	font-size: 0.09rem;
	text-align: center;
	height: 0.3rem;
	border-radius: 0.3rem;
	background: #3b97ff;
	color: white;
	padding: 0.04rem 0.09rem;
	display: flex;
	align-items: center;
}
.qiye .line-title::after {
	background: #6ed2ae;
}
.qiye .pillar div {
	background: #6ed2ae;
}
.geren .line-title::after {
	background: #ffb751;
}
.geren .pillar div {
	background: #ffb751;
}

/* 六张保单 */
.policy li {
	margin-bottom: 0.2rem;
}
.policy li:nth-last-child(1) {
	margin-bottom: 0.08rem;
}
.policy li img {
	display: block;
	width: 0.41rem;
	height: 0.41rem;
	margin-right: 0.15rem;
	overflow: hidden;
}
.policy li > div {
	flex: 1;
}
.policy li div h3 {
	font-weight: 800;
	color: #1b3654;
	font-size: 0.15rem;
	line-height: 0.36rem;
}
.policy li div p {
	font-size: 0.12rem;
	font-weight: 500;
	color: #617080;
}

/* 按钮 */
footer {
	width: 100%;
	padding: 0 0.15rem;
	position: fixed;
	bottom: 0;
	left: 0;
	box-sizing: border-box;
}
.btn {
	width: 100%;
	height: 0.37rem;
	background: #3b97ff;
	border-radius: 0.37rem;
	line-height: 0.37rem;
	border: none;
	font-size: 0.15rem;
	font-weight: bold;
	color: #ffffff;
	margin: 0.2rem 0;
	box-shadow: 0rem 0.03rem 0.05rem #3b97ff;
}
</style>
